import Quill from "quill";
import { AlignClass } from "quill/formats/align";

// Register align format early so ReactQuill/Quill uses class-based alignment
Quill.register({ "formats/align": AlignClass }, true);

export const quillSetup = true;
